import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PolicyAction, PolicyFormValues } from '../policy-dialog';
import z from 'zod';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

interface ChangeImapActionProps {
  setValue: UseFormSetValue<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
}

export const ChangeImapActionSchema = z.object({
  type: z.literal('Change_IMAP'),
  gmailIMAP: z.string().optional(),
});

export type ChangeImapActionType = z.infer<typeof ChangeImapActionSchema>;

// Type guard to check if an action is ChangeGpanelRoleActionType
function isChangeImapAction(
  action: PolicyAction
): action is ChangeImapActionType {
  return action.type === 'Change_IMAP';
}

export default function ChangeImapAction({
  setValue,
  watch,
}: ChangeImapActionProps) {
  const actionData = watch('actionData');
  const idx = actionData.map((action) => action.type).indexOf('Change_IMAP');
  const actionAtIndex = actionData[idx];
  if (!isChangeImapAction(actionAtIndex)) {
    return null;
  }

  const currentAction: ChangeImapActionType = actionAtIndex;

  return (
    <Stack>
      <Stack gap={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={currentAction.gmailIMAP === 'true'}
              onChange={() =>
                setValue(
                  `actionData.${idx}.gmailIMAP`,
                  currentAction.gmailIMAP === 'true' ? 'false' : 'true'
                )
              }
            />
          }
          sx={{ width: 'fit-content' }}
          label="Imap Enabled"
        />
      </Stack>
    </Stack>
  );
}
